import {Component, EventEmitter, Inject, Input, Output} from '@angular/core';

@Component({
  selector: 'app-menu',
  template: `
    <nav class="navbar navbar-expand-lg fixed-top white-menu">
      <a class="navbar-brand" routerLink="/">
        USDA
      </a>
      <div class="collapse navbar-collapse justify-content-between main-menu" id="navbarSupportedContent">
        <ul class="navbar-nav" routerLinkActive="active">
         <li *ngIf="showAdminLink()" class="nav-item">
            <a class="nav-link" routerLink="admin" routerLinkActive="active">Admin</a>
          </li>
        </ul>
        <div *ngIf="loggedIn" class="text-right heading-overlay">
          <div class="btn-group" dropdown class="user-menu">
            <button dropdownToggle
                    type="button"
                    class="btn btn-outline-primary btn-sm user-menu"
                    [ngClass]="{'btn-outline-warning': isAliasing}">
              {{name}} <i class="fa fa-cog"></i>
            </button>
            <ul *dropdownMenu class="dropdown-menu small" role="menu">
              <li *ngIf="role !== 'User'" role="menuitem"><a class="dropdown-item" routerLink="/userprofile">Edit Profile</a></li>
              <li role="menuitem"><a class="dropdown-item" routerLink="/changepassword">Change Password</a></li>
              <li role="menuitem"><a class="dropdown-item" (click)="logOut.emit()">Logout</a></li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
      `,
  styles: [`
    .navbar-brand{
      margin-right:50px;
    }
    .white-menu {
      border-bottom:1px solid #efefef;
      background:rgba(255,255,255,0.85);
    }
    .user-menu {
      border-color:#00ADEF!important;
      color:#fff!important;
    }
    .user-menu:hover {
      cursor:pointer;
    }
    .main-menu {
      margin-top:-10px;
    }
    .user-menu:active, .user-menu:focus, .user-menu:hover {
      background-color:transparent!important;
      box-shadow: transparent!important;
    }
    .dropdown-menu {
      margin: 0 0 0 275px;
      font-size:.8em!important;
      padding:0!important;
      min-width: 6rem!important;
    }
    .btn-outline-primary:focus {
      box-shadow: 0 0 0 0 white;
    }
    .btn-outline-primary:active, .btn-outline-primary.active, .show > .btn-outline-primary.dropdown-toggle {
      background-color:#00ADEF!important;
      color: #ccc!important;
    }
    .dropdown-item {
      padding: 2px 10px;!important;
      color: #292b2c!important;
    }
    .role-section {
      line-height:32px;
      margin: 0 0 0 30px;
      font-weight:normal;
    }
    .heading-overlay {
      border-bottom: 1px solid #21409a;
      border-left: 1px solid #21409a;
      background-color: #00ADEF;
      position: fixed;
      height: 32px;
      top: 0;
      left: 100%;
      margin-left: -400px;
      width: 400px;
      z-index: 1050 !important;
      font-size: 13px !important;
      line-height: 20px;
      font-weight: bold;
      text-align: center;
      border-radius: 0 0 0 30px;
      color: #fff;
      box-shadow: 0 2px 5px #888888;
    }
  `]
})
export class AppMenuComponent {
  @Input() loggedIn: boolean;
  @Input() isAdmin: boolean;
  @Input() isSuperAdmin: boolean;
  @Input() name: string;
  @Input() isAliasing: boolean;
  @Input() role: string;
  @Output() logOut: EventEmitter<any> = new EventEmitter();

  constructor(@Inject('ApplicationConfig') private config: any) { }

  showAdminLink() {
    return this.loggedIn && (this.role === 'Super Administrator' || this.role === 'Administrator');
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/app-menu.ts